import React, { useState } from 'react';
import styles from './MobileNav.module.scss';
import { NavLink } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';

const MobileNav = props => {
  return (
    <div className={` ${props.isMobileMenuOpen ? styles.open : null}`}>
      <div className={`${styles.sidenav}`}>
        <div className={`${styles.mobileNavWrap}`}>
          <div className={styles.title}>
            Menu
            <button
            className={styles.button}
            onClick={() => props.setMobileMenuVisibility(false)}
            onKeyPress={event => {console.log(event.which);
              if (event.which==13) {console.log("pressed ener");
              props.setMobileMenuVisibility(false);
              }
            }}
          >
            <CloseIcon
              className={styles.menuIcon}
            />
            </button>
          </div>
          <nav className={styles.mobileNav}>
            <NavLink
              exact
              activeStyle={{ color: '#447b75', fontSize: '16px', fontWeight: '600' }}
              to={'/'}
            >
              Home
            </NavLink>
            <NavLink
              exact
              activeStyle={{ color: '#447b75', fontSize: '16px', fontWeight: '600' }}
              to={'/participating-organisations'}
            >
              Participating organisations
            </NavLink>
            <NavLink
              exact
              activeStyle={{ color: '#447b75', fontSize: '16px', fontWeight: '600' }}
              to={'/support'}
            >
              Support services
            </NavLink>
            <NavLink
              exact
              activeStyle={{ color: '#447b75', fontSize: '16px', fontWeight: '600' }}
              to={'/help-centre'}
            >
              Help centre
            </NavLink>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
